import {  
  PENDING, FULFILLED, REJECTED, 
  STATS__MODAL_STATS__TOGGLE,
  STATS__MODAL_STATS__SELECT_OFFICE,
  STATS__MODAL_STATS__GET_OFFICES,
  STATS__MODAL_STATS__GET_STATS,
} from '../globals';

export const initialState = {
  modalData: {
    isOpen: false,
    defaultOffice: null,
    selectedOffice: null,
  },
  officesDDData: {
    isLoading: false,
    status: false,
    error: false,
    data: [],
    errorMessage: '',
  },
  statsData: {
    isLoading: false,
    status: false,
    error: false,
    data: [],
    errorMessage: '',
  },
};

const reducer = (state = initialState, action) => {
  const { payload, } = action;
  switch (action.type) {

    /**
     * Modal Stats - Toggle
     */
    case `${STATS__MODAL_STATS__TOGGLE}`: {
      return {
        ...state,
        modalData: {
          ...state.modalData,
          isOpen: !state.modalData.isOpen,
          defaultOffice: payload.defaultOffice,
        },
        statsData: {
          ...initialState.statsData,
        }
      }
    }

    /**
     * Modal Stats - Select Offife
     */
    case `${STATS__MODAL_STATS__SELECT_OFFICE}`: {
      return {
        ...state,
        modalData: {
          ...state.modalData,
          selectedOffice: payload.office,
        }
      }
    }


    /**
     * Modal Stats - Get Offices DD
     */
    case `${STATS__MODAL_STATS__GET_OFFICES}_${PENDING}`: {
      return {
        ...state,
        officesDDData: {
          ...initialState.officesDDData,
          isLoading: true,
        }
      };
    }
    

    case `${STATS__MODAL_STATS__GET_OFFICES}_${FULFILLED}`: {
      let officesDD = [];
      let selectedOffice = null;

      for (let i = 0; i < payload.data.length; i++) {
        officesDD.push({
          id: payload.data[i].id,
          name: payload.data[i].pub_server_name,
        });

        if (state.modalData.defaultOffice !== null && (state.modalData.defaultOffice).toString() === (payload.data[i].id).toString()) {
          selectedOffice = {
            id: payload.data[i].id,
            name: payload.data[i].pub_server_name,
          };
        }
      }

      return {
        ...state,
        officesDDData: {
          ...state.officesDDData,
          isLoading: false,
          status: payload.status,
          data: officesDD,
        },
        modalData: {
          ...state.modalData,
          selectedOffice: selectedOffice,
        }
      };
    }
    

    case `${STATS__MODAL_STATS__GET_OFFICES}_${REJECTED}`: {
      return {
        ...state,
        officesDDData: {
          ...state.officesDDData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      }
    }

    
    /**
     * Modal Stats - Get Offices DD
     */
    case `${STATS__MODAL_STATS__GET_STATS}_${PENDING}`: {
      return {
        ...state,
        statsData: {
          ...initialState.statsData,
          isLoading: true,
        }
      };
    }
    

    case `${STATS__MODAL_STATS__GET_STATS}_${FULFILLED}`: {
        return {
        ...state,
        statsData: {
          ...state.statsData,
          isLoading: false,
          status: payload.status,
          data: payload.data,
        },
      };
    }
      

    case `${STATS__MODAL_STATS__GET_STATS}_${REJECTED}`: {
      return {
        ...state,
          statsData: {
          ...state.statsData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      }
    }
   
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/stats.js